import initState1 from '../../softdata.json';
const initState = {
    ...initState1[0].project
}
const projectReducer = (state = initState, action) => {
    return state;  
}
export default projectReducer